import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "f-16 sz-secondary-grey--text font-weight-medium d-inline-block mb-0" }
const _hoisted_2 = ["onClick"]



type Props = {
    limitList: number[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'LimitList',
  props: /*@__PURE__*/_mergeModels({
    limitList: {}
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const props = __props;

const currentLimit = _useModel<number>(__props, "modelValue");

const setLimit = (limit: number) => {
    currentLimit.value = limit;
};

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!

  return (_openBlock(), _createBlock(_component_v_col, {
    cols: "12",
    sm: "6",
    "align-self": "center",
    class: "d-flex justify-center justify-sm-start"
  }, {
    default: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.$t('label.perPage')) + ": ", 1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.limitList, (item, index) => {
        return (_openBlock(), _createElementBlock("p", {
          key: index,
          class: _normalizeClass([{ 'primary-link' : currentLimit.value !== item }, "f-16 font-weight-medium d-inline-block ml-2 pointer text-black mb-0"]),
          onClick: ($event: any) => (setLimit(item))
        }, _toDisplayString(item), 11, _hoisted_2))
      }), 128))
    ]),
    _: 1
  }))
}
}

})